import { useAuthContext } from "@auth/context/Auth.context";
import { ClbHeaderIconButtons } from "@celebration/react";
import { Avatar, Button, Dropdown, Tooltip } from "@components/index";
import HeaderButtonConfiguration from "./HeaderButtonConfiguration";
import HeaderButtonDelayManagement from "./HeaderButtonDelayManagement";
import HeaderButtonLogout from "./HeaderButtonLogout";
import HeaderButtonProcesses from "./HeaderButtonProcesses";
import HeaderButtonReport from "./HeaderButtonReport";

const HeaderButtons = () => {
  const { hasSomeResourceRole, userDisplayName } = useAuthContext();
  const userDisplayInitial = userDisplayName?.[0].toUpperCase();
  const trigger = <Button icon="menu" size="sm" buttonStyle="tertiary" />;

  return (
    <ClbHeaderIconButtons>
      <Tooltip position="bottom" title={userDisplayName}>
        <Avatar size="md" label={userDisplayInitial} />
      </Tooltip>

      <Dropdown position="bottomRight" trigger={trigger}>
        {(close) => (
          <>
            <HeaderButtonProcesses
              close={close}
              show={hasSomeResourceRole("admin", "timeline-manager")}
            />

            <HeaderButtonConfiguration close={close} />
            <HeaderButtonDelayManagement
              close={close}
              show={hasSomeResourceRole("admin", "timeline-manager")}
            />
            <HeaderButtonReport close={close} />

            <HeaderButtonLogout close={close} />
          </>
        )}
      </Dropdown>
    </ClbHeaderIconButtons>
  );
};

export default HeaderButtons;
